// extracted by mini-css-extract-plugin
export default {"NoData":"Report_NoData__jY819"};